export default __webpack_public_path__ + "static/media/logo.e87092fe.png";